import { Injectable, inject } from '@angular/core';
import { Observable, map, shareReplay } from 'rxjs';
import { ReferenceService, SegmentTypeResponse } from '../../api';
import { OptionsData } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class SegmentTypeService {
  private referenceService = inject(ReferenceService);

  // Cache the segment types using shareReplay to ensure the API is only called once
  private segmentTypes$: Observable<OptionsData<string>[]> | null = null;

  /**
   * Gets segment types from the API and maps them to the expected format.
   * Uses RxJS shareReplay to cache the result and ensure only one API call is made.
   */
  getSegmentTypes(): Observable<OptionsData<string>[]> {
    if (!this.segmentTypes$) {
      this.segmentTypes$ = this.referenceService
        .apiV1ReferenceSegmentTypesGet()
        .pipe(
          map((response: SegmentTypeResponse[]) =>
            response.map(item => ({
              label: item.name || '',
              value: item.code || '',
            }))
          ),
          shareReplay(1) // Cache the result and replay to new subscribers
        );
    }
    return this.segmentTypes$;
  }
}
